// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terminal-info-page .all-salons-note {
  margin: 0 0 10px;
}
.terminal-info-page .terminal-progress {
  margin: 0 0 10px;
  font-size: 11px;
}
.terminal-info-page .terminal-salons {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 10px;
}
.terminal-info-page .terminal-salons .terminal-balance {
  margin-bottom: 0;
  align-self: start;
}
.terminal-info-page .terminal-salon-heading {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.terminal-info-page .terminal-salon-heading h2 {
  flex: 1 1;
  min-width: 0;
  font-size: 14px;
  line-height: 1.4;
  margin: 0;
  overflow-wrap: anywhere;
}
.terminal-info-page .terminal-point-details {
  border-top: 1px solid #edf0f5;
  margin-top: 8px;
}
.terminal-info-page .terminal-point-details summary {
  font-size: 12px;
  color: #78849a;
}
.terminal-info-page .terminal-point-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 8px;
}
.terminal-info-page .terminal-balance {
  padding: 18px;
}
.terminal-info-page .terminal-balance > .compact-muted {
  font-size: 12px;
}
.terminal-info-page .terminal-balance-value {
  display: block;
  font-size: 30px;
  line-height: 1.3;
  letter-spacing: -0.04em;
  font-variant-numeric: tabular-nums;
  margin-block: 8px;
  overflow-wrap: anywhere;
}
.terminal-info-page .terminal-update-time {
  color: #78849a;
  font-size: 11px;
  margin: 0;
}
.terminal-info-page .terminal-balance-details {
  margin-top: 12px;
  border-top: 1px solid #edf0f5;
}
.terminal-info-page .terminal-balance-details summary {
  font-size: 12px;
  color: #78849a;
}
.terminal-info-page .terminal-action {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  color: #232137;
  min-height: 76px;
  box-sizing: border-box;
}
.terminal-info-page .terminal-action > span:nth-child(2) {
  flex: 1 1;
  min-width: 0;
  display: grid;
  gap: 5px;
}
.terminal-info-page .terminal-action strong {
  font-size: 14px;
}
.terminal-info-page .terminal-action small {
  color: #78849a;
  font-size: 11px;
  line-height: 1.5;
}
.terminal-info-page .terminal-action > svg {
  width: 16px;
  color: #78849a;
  transform: rotate(-90deg);
  flex-shrink: 0;
}
.terminal-info-page .terminal-action-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background: #fff1f4;
  border-radius: 12px;
  color: #e72f44;
  flex: 0 0 40px;
}
.terminal-info-page .terminal-action-icon > svg {
  width: 22px;
}
.terminal-info-page .terminal-help h2 {
  font-size: 15px;
  margin-bottom: 6px;
}
.terminal-info-page .terminal-help p {
  margin: 0 0 12px;
}
.terminal-info-page .terminal-help > a {
  font-size: 12px;
}
@media (max-width: 650px) {
  .terminal-info-page .terminal-salons {
    grid-template-columns: minmax(0, 1fr);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/TerminalInfoPage/terminalCompact.scss"],"names":[],"mappings":"AACE;EAAmB,gBAAA;AACrB;AAAE;EAAqB,gBAAA;EAAkB,eAAA;AAIzC;AAHE;EAAmB,aAAA;EAAe,gDAAA;EAAkD,SAAA;EAAW,mBAAA;AASjG;AARE;EAAqC,gBAAA;EAAkB,iBAAA;AAYzD;AAXE;EAA0B,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,kBAAA;AAiB1E;AAjB8F;EAAK,SAAA;EAAS,YAAA;EAAc,eAAA;EAAiB,gBAAA;EAAkB,SAAA;EAAW,uBAAA;AAyBxK;AAxBE;EAA0B,6BAAA;EAA+B,eAAA;AA4B3D;AA5B4E;EAAU,eAAA;EAAiB,cAAA;AAgCvG;AA/BE;EAA0B,aAAA;EAAe,eAAA;EAAiB,QAAA;EAAU,kBAAA;AAqCtE;AApCE;EAAoB,aAAA;AAuCtB;AAtCE;EAAqC,eAAA;AAyCvC;AAxCE;EAA0B,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,uBAAA;EAAwB,kCAAA;EAAoC,iBAAA;EAAmB,uBAAA;AAiD9J;AAhDE;EAAwB,cAAA;EAAgB,eAAA;EAAiB,SAAA;AAqD3D;AApDE;EAA4B,gBAAA;EAAkB,6BAAA;AAwDhD;AAxD+E;EAAU,eAAA;EAAiB,cAAA;AA4D1G;AA3DE;EAAmB,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,qBAAA;EAAuB,cAAA;EAAgB,gBAAA;EAAkB,sBAAA;AAoE7H;AApEqJ;EAAsB,SAAA;EAAS,YAAA;EAAc,aAAA;EAAe,QAAA;AA0EjN;AA1E6N;EAAS,eAAA;AA6EtO;AA7EyP;EAAQ,cAAA;EAAgB,eAAA;EAAiB,gBAAA;AAkFlS;AAlFsT;EAAQ,WAAA;EAAa,cAAA;EAAgB,yBAAA;EAA2B,cAAA;AAwFtX;AAvFE;EAAwB,aAAA;EAAe,uBAAA;EAAyB,mBAAA;EAAqB,WAAA;EAAa,YAAA;EAAc,mBAAA;EAAqB,mBAAA;EAAqB,cAAA;EAAgB,cAAA;AAkG5K;AAlG4L;EAAQ,WAAA;AAqGpM;AApGmB;EAAK,eAAA;EAAiB,kBAAA;AAwGzC;AAxG+D;EAAI,gBAAA;AA2GnE;AA3GuF;EAAM,eAAA;AA8G7F;AA7GE;EAA4B;IAAmB,qCAAA;EAiH/C;AACF","sourcesContent":[".terminal-info-page {\n  .all-salons-note { margin: 0 0 10px; }\n  .terminal-progress { margin: 0 0 10px; font-size: 11px; }\n  .terminal-salons { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; margin-bottom: 10px; }\n  .terminal-salons .terminal-balance { margin-bottom: 0; align-self: start; }\n  .terminal-salon-heading { display: flex; align-items: center; gap: 8px; margin-bottom: 8px; h2 { flex: 1; min-width: 0; font-size: 14px; line-height: 1.4; margin: 0; overflow-wrap: anywhere; } }\n  .terminal-point-details { border-top: 1px solid #edf0f5; margin-top: 8px; summary { font-size: 12px; color: #78849a; } }\n  .terminal-point-actions { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 8px; }\n  .terminal-balance { padding: 18px; }\n  .terminal-balance > .compact-muted { font-size: 12px; }\n  .terminal-balance-value { display: block; font-size: 30px; line-height: 1.3; letter-spacing: -.04em; font-variant-numeric: tabular-nums; margin-block: 8px; overflow-wrap: anywhere; }\n  .terminal-update-time { color: #78849a; font-size: 11px; margin: 0; }\n  .terminal-balance-details { margin-top: 12px; border-top: 1px solid #edf0f5; summary { font-size: 12px; color: #78849a; } }\n  .terminal-action { display: flex; align-items: center; gap: 12px; text-decoration: none; color: #232137; min-height: 76px; box-sizing: border-box; > span:nth-child(2) { flex: 1; min-width: 0; display: grid; gap: 5px; } strong { font-size: 14px; } small { color: #78849a; font-size: 11px; line-height: 1.5; } > svg { width: 16px; color: #78849a; transform: rotate(-90deg); flex-shrink: 0; } }\n  .terminal-action-icon { display: flex; justify-content: center; align-items: center; width: 40px; height: 40px; background: #fff1f4; border-radius: 12px; color: #e72f44; flex: 0 0 40px; > svg { width: 22px; } }\n  .terminal-help { h2 { font-size: 15px; margin-bottom: 6px; } p { margin: 0 0 12px; } > a { font-size: 12px; } }\n  @media (max-width: 650px) { .terminal-salons { grid-template-columns: minmax(0, 1fr); } }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
